import { http } from 'utils'

// Talent tags mutation imports.
import { SET_TAGS, REPLACE_TAGS } from 'vx/mutations'

// Talent tags state.
const state = {
  tags: []
}

// Talent tags state getters.
const getters = {}

// Talent tags actions.
const actions = {
  /**
   * Get a talents tags.
   *
   * @return Promise
   */
  getTalentTags ({ commit }, { id }) {
    return http.get(`users/${id}/talent_tags`)
      .then((response) => {
        commit(SET_TAGS, response.data)

        return response
      })
  },

  /**
   * Update a talents tags.
   *
   * @return Promise
   */
  updateTalentTags ({ commit }, { id, payload }) {
    return http.put(`users/${id}/talent_tags`, payload)
  },

  replaceTags ({ commit }, { type, tags }) {
    commit(REPLACE_TAGS, { type, tags })
  }
}

// Talent tags state mutations.
const mutations = {
  [SET_TAGS] (state, tags) {
    state.tags = tags
  },

  [REPLACE_TAGS] (state, { type, tags }) {
    state.tags[type] = tags
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
